import { createSignal } from '@verclam/pulsar';

/**
 * Three mutually exclusive modes for the same panel. A `roleId`/`sourceRoleId` pair carried as two
 * optional fields on a single shape would let `{ roleId: 5, sourceRoleId: 3 }` type-check while making
 * no sense: the discriminated union rules it out entirely.
 */
export type RoleSidebarContext =
	| { readonly type: 'create' }
	| { readonly type: 'edit'; readonly roleId: number }
	| { readonly type: 'duplicate'; readonly sourceRoleId: number };

const roleSidebarSignal = createSignal<RoleSidebarContext | null>(null);

export const openRoleSidebar = (): void => {
	roleSidebarSignal.value = { type: 'create' };
};

export const editRoleInSidebar = (roleId: number): void => {
	roleSidebarSignal.value = { type: 'edit', roleId };
};

export const duplicateRoleInSidebar = (sourceRoleId: number): void => {
	roleSidebarSignal.value = { type: 'duplicate', sourceRoleId };
};

export const closeRoleSidebar = (): void => {
	roleSidebarSignal.value = null;
};

export default roleSidebarSignal;
